import { gridMap } from '../mapgrid.ts';
import { withGeometry } from '../mapgeo.ts';
import { PARK_GEO } from './parkgeo.ts';

const PARK_GRID = gridMap('Park', `
  hhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhh
  hhh.........................................................
  hhh.........................................................
  h..............h............................................
  h..............h..........FF................................
  h....RRRRRRRR..h..........FF................................
  h....RRRRRRRR..h............................................
  h....RRRRRRRR..h............................................
  h....RRRRRRRR..h...................hhhhhhh....hhhhhhhh......
  h....RRRRRRRR..h...................h.................h......
  h....RRRRRRRR..h...................h.................h....nn
  h....RRRRRRRR..h...................h.................h....nn
  h....RRRRRRRR......................h..yyyyyyy........h......
  h..................................h.................h......
  h...............................................yy..........
  h..hhhhhhhhhh...................................yy..........
  h...........................l...................yy..........
  h.........l.....................................yy..........
  h...............m..................h............yy...h.h....
  h..................................h............yy...h.h....
  h.........c........................h...y....c........h.nnn..
  h..................................h...y.............h.nnn..
  h..................................h...y.............h.h..nn
  h..................................h...y..tttttt.....h.h..nn
  h..................................h...y..t....t.....h.h....
  h..................................h......t..........h.h....
  h...........................l......h......t..........h.h....
  h..................................h......t....t.....h.h....
  h..................................h......tttttt.....hp.....
  h..................................h.................h......
  h..................................hhhhhhh....hhhhhhhh......
  h...........................................................
  h.....FF...............................................h....
  h.....FF...............................................h....
  h...........b.........A.................a..............h....
  h......................................................h....
  h...................................c..................h....
  h......................................................h....
  h......................................................hc...
  h......................................................h....
  h...........................................................
  h............................nnnn...........................
  h...........g...........i...................................
  h....hhhhhhhh...hhhhhhhh....................................
  h....h.................h....c...............FF............hh
  h....h.................h....................FF............hh
  h............tt...........................................hh
  h............tt.............................................
  h...........................................................
  h....h..nnn............h....................................
  h....h.................h....................................
  h....hhhhhhhh...hhhhhhhh....................................
  h.............................................FF....l.......
  h...................l...............l.........FF............
  h...........................................................
  h.............hhhhhhhhhhhh....hhhhhhhhhhhh..................
  h...........................................................
  h.................t...t.....................................
  h.......................c...................................
  h...........................................................
  h...........................................................
  h...........................................................
  h.......FF........t...t.....................................
  h.......FF..................................................
  h.............hhhhhhhhhhhh....hhhhhhhhhhhh..................
  h...........................................................
  h...................l...............l.......................
  h...........................................................
  h......................................hhh..hhh..hhhl.hhh...
  h......................................h......h..h......h...
  h.FF...................................h......h..h..c...h...
  h.FF........................................................
  h...........................................................
  h......................................h......h..h......h.hh
  h......................................h......h..h......h.hh
  h......................................hhh..hhh..hhh..hhh.hh
  h.......a...................................................
  h...........................................................
  h.................c....................hhh..hhh..hhh..hhh...
  h......................................h......h..h......h...
  h......................................h......h..h......h...
  h...........................................................
  h...........................................................
  h..................www....www..........h......h..h......h...
  h...............wwwwww....wwwwww.......h......h..h..bb..h...
  h.............wwwwwwww....wwwwwwww.....hhh..hhh..hhh..hhh...
  h............wwwwwwwww....wwwwwwwww.........................
  h...........wwwwwwwwww....wwwwwwwwww........................
  h..........wwwwwwwwwww....wwwwwwwwwww.......................
  h..........wwwwwwwwwww....wwwwwwwwwww.......................
  h.........wwwwwwwwwwww....wwwwwwwwwwww......................
  h.........wwwwwwwwwwww....wwwwwwwwwwww......................
  h...c.....wwwwwwwwwwww....wwwwwwwwwwww..................m...
  h.........wwwwwwwwwwww....wwwwwwwwwwww......................
  h..........wwwwwwwwwww....wwwwwwwwwww.......................
  h..........wwwwwwwwwww....wwwwwwwwwww.......................
  h...........wwwwwwwwww....wwwwwwwwww........l..............n
  h............wwwwwwwww....wwwwwwwww........................n
  h.............wwwwwwww....wwwwwwww..........................
  h...............wwwwww....wwwwww............................
  h.........l........www....www...............................
  h...........................................................
  h...........................................................
  h...........................................................
  h...........................................................
  h................................e..........................
  h.................................tttttttt..bb..............
  h.................................tttttttt..b...............
  h.................................tttttttt..............nnnn
  h.................................tttttttt..............nnnn
  h.............................................c.....FF......
  h.........................................o.........FF......
  h.............FF............................................
  h.............FF............................................
  h...........................................................
  h...........................................................
  h...........................................................
  h...........................................................
  h...........................................................
  hhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhh
`, 'park');

/** The bandstand, fountain rims, trunks, curved hedges, boathouse and cafe kiosk are polygons (parkgeo.ts); the cells they replaced are empty here. */
export const PARK = withGeometry(PARK_GRID, PARK_GEO);
